module.exports = __webpack_public_path__ + "static/media/lander.56eabb6a.PNG";